import type { JobApplication } from '@openclassrooms/sdk-web';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { UseFindParams } from '../../utils/services/getUseFind';
import { clientApi } from '../../configuration';

const { useFind: useUserJobApplications, useCreate: useCreateUserJobApplication } = getCRUDHooks<
  JobApplication,
  {},
  UseFindParams,
  { userId: number | null }
>({
  entityName: 'userJobApplication',
  create: (jobApplication, params) => {
    if (!params?.userId) {
      throw new Error(
        'useCreateUserJobApplication needs a userId: useCreateUserJobApplication(newJobApplication, { userId: "123" })'
      );
    }
    return clientApi
      .getOCClient()
      .helpers.user.users.id(params.userId)
      .jobApplications.create(jobApplication);
  },
  find: ({ userId, filters }) => {
    if (userId) {
      return clientApi.getOCClient().helpers.user.users.getJobApplications(userId, filters);
    }

    return clientApi.getOCClient().helpers.user.me.getJobApplications(filters);
  },
});

// eslint-disable-next-line import/prefer-default-export
export { useUserJobApplications, useCreateUserJobApplication };
